(() => {
  const root = (window.ButterAtelier && window.ButterAtelier.root) || '/';
  const currency = (window.ButterAtelier && window.ButterAtelier.currency) || 'BHD';

  const $ = (selector, context = document) => context.querySelector(selector);
  const $$ = (selector, context = document) => [...context.querySelectorAll(selector)];

  function formatMoney(cents, code = currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: code, minimumFractionDigits: code === 'BHD' ? 3 : 2
      }).format((Number(cents) || 0) / 100);
    } catch (_) {
      return `${code} ${((Number(cents) || 0) / 100).toFixed(code === 'BHD' ? 3 : 2)}`;
    }
  }

  function escapeHTML(value = '') {
    const div = document.createElement('div');
    div.textContent = value;
    return div.innerHTML;
  }

  function toast(message) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.classList.add('show');
    clearTimeout(el._timer);
    el._timer = setTimeout(() => el.classList.remove('show'), 1800);
  }

  async function getCart() {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Could not load cart');
    return response.json();
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
    const itemsWrap = $('[data-cart-items]');
    const total = $('[data-cart-total]');
    if (total) total.textContent = formatMoney(cart.total_price, cart.currency || currency);
    if (!itemsWrap) return;

    if (!cart.items.length) {
      itemsWrap.innerHTML = '<p class="muted" style="padding:30px 0">Your cart is empty.</p>';
      return;
    }

    itemsWrap.innerHTML = cart.items.map((item, index) => {
      const image = item.featured_image?.url || item.image || '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<small>${escapeHTML(item.variant_title)}</small>` : '';
      const properties = Object.entries(item.properties || {})
        .filter(([, value]) => value)
        .map(([key, value]) => `<small>${escapeHTML(key)}: ${escapeHTML(String(value))}</small>`)
        .join('');
      return `<div class="cart-item">
        <div class="cart-thumb">${image ? `<img src="${escapeHTML(image)}" alt="">` : ''}</div>
        <div><h4>${escapeHTML(item.product_title)}</h4>${variant}${properties}<small>Quantity: ${item.quantity}</small><div class="cart-line-price">${formatMoney(item.final_line_price, cart.currency || currency)}</div></div>
        <button type="button" aria-label="Remove ${escapeHTML(item.product_title)}" data-cart-remove data-line="${index + 1}">×</button>
      </div>`;
    }).join('');

    $$('[data-cart-remove]', itemsWrap).forEach(button => {
      button.addEventListener('click', () => changeCart(Number(button.dataset.line), 0));
    });
  }

  async function refreshCart() {
    try { renderCart(await getCart()); } catch (_) {}
  }

  async function changeCart(line, quantity) {
    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      if (!response.ok) throw new Error('Could not update cart');
      renderCart(await response.json());
    } catch (error) { toast(error.message); }
  }

  async function openCart() {
    const drawer = $('[data-cart-drawer]');
    const overlay = $('[data-cart-overlay]');
    if (!drawer) { window.location.href = `${root}cart`; return; }
    await refreshCart();
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    const drawer = $('[data-cart-drawer]');
    const overlay = $('[data-cart-overlay]');
    drawer?.classList.remove('open');
    drawer?.setAttribute('aria-hidden', 'true');
    overlay?.classList.remove('open');
    document.body.style.overflow = '';
  }

  async function addProduct(form) {
    const button = $('[data-add-to-cart]', form);
    const label = $('[data-add-label]', button || form);
    const original = label?.textContent;
    if (button) button.disabled = true;
    if (label) label.textContent = 'Adding…';

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Could not add to cart');
      await openCart();
      toast('Added to cart');
    } catch (error) {
      toast(error.message || 'Could not add to cart');
    } finally {
      if (button) button.disabled = false;
      if (label) label.textContent = original || 'Add to cart';
    }
  }

  function initProduct(section) {
    const form = $('.product-form', section);
    const qty = $('[data-qty-value]', section);
    const minus = $('[data-qty-minus]', section);
    const plus = $('[data-qty-plus]', section);
    const select = $('[data-variant-select]', section);
    const variantsJSON = $('[data-product-variants]', section);
    const price = $('[data-product-price]', section);
    const addButton = $('[data-add-to-cart]', section);
    const addLabel = $('[data-add-label]', section);
    let variants = [];
    try { variants = JSON.parse(variantsJSON?.textContent || '[]'); } catch (_) {}

    minus?.addEventListener('click', () => { qty.value = Math.max(1, (Number(qty.value) || 1) - 1); });
    plus?.addEventListener('click', () => { qty.value = Math.max(1, (Number(qty.value) || 1) + 1); });

    select?.addEventListener('change', () => {
      const variant = variants.find(v => String(v.id) === select.value);
      if (!variant) return;
      if (price) price.innerHTML = `<span>${escapeHTML(variant.priceFormatted || '')}</span>${variant.compareAtFormatted ? ` <s>${escapeHTML(variant.compareAtFormatted)}</s>` : ''}`;
      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    });

    form?.addEventListener('submit', event => {
      if (event.submitter && !event.submitter.matches('[data-add-to-cart]')) return;
      event.preventDefault();
      addProduct(form);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    $$('[data-cart-open]').forEach(button => button.addEventListener('click', openCart));
    $$('[data-cart-close]').forEach(button => button.addEventListener('click', closeCart));
    $('[data-cart-overlay]')?.addEventListener('click', closeCart);
    $$('[data-product-section]').forEach(initProduct);

    $$('[data-accordion]').forEach(button => button.addEventListener('click', () => {
      const item = button.closest('.accordion-item');
      const open = item.classList.toggle('open');
      button.setAttribute('aria-expanded', String(open));
    }));

    document.addEventListener('keydown', event => { if (event.key === 'Escape') closeCart(); });
  });

  document.addEventListener('shopify:section:load', event => {
    $$('[data-product-section]', event.target).forEach(initProduct);
  });
})();
